import * as React from "react";

import { style, MyIconProps } from "./MyIcons";

export const LockProtectionCheckmark = (
  props: MyIconProps,
): React.ReactElement => {
  return (
    <svg
      ref={props.elementRef}
      className={props.className}
      style={{ ...style(props), ...props.style }}
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    >
      <path d="M13.0004 21.0036H6.99792C5.89289 21.0036 4.99708 20.1078 4.99708 19.0028V11.9999C4.99708 10.8948 5.89289 9.99902 6.99792 9.99902H17.0021C18.1071 9.99902 19.0029 10.8948 19.0029 11.9999V13.0003" />
      <path d="M20.0033 17.002L17.5023 19.503L16.0017 18.0024" />
      <path d="M7.99833 9.99901V6.99776V6.99776C7.99833 4.7877 9.78994 2.99609 12 2.99609V2.99609C14.2101 2.99609 16.0017 4.7877 16.0017 6.99776V6.99776V9.99901" />
    </svg>
  );
};
